/* I actually recommend making this component completely dumb. It shouldn't know how changes are calculated. The backend (or the layout) can eventually pass in the summary object.

That means later, when you add change tracking, this component won't need to change. */
import { AlertCircle } from "lucide-react";

const ChangeSummary = ({ summary , waiver }) => {

    // Temporary placeholder values until backend supplies them
    const data = {
        eligibilityRulesModified: 0,
        sectionsEdited: 0,
        clausesAdded: 0,
        minorsChanged: false,
        returningSignerChanged: false,
        stateClausesModified: 0,
        ...(summary && typeof summary === "object" ? summary : {}),
    };

    const isNewVersion = waiver?.waiverStatus === "new_version";

    if (!isNewVersion) {
        return null;
    }
   
    return (

        <div className="border rounded-2xl bg-white p-6 mb-8">

            <div className="flex items-start gap-3">

                {isNewVersion && (
                <AlertCircle
                    size={18}
                    className="text-red-500 mt-1 flex-shrink-0"
                />
                )}

                <div>

                    {isNewVersion && (
                        <>
                            <h3 className="font-medium text-gray-900">
                                {/* Changes apply to new signers only */}
                                This draft is not live yet
                            </h3>

                            <p className="text-sm text-gray-600 mt-1">
                               {/*  Publishing creates a new legal version.
                                Past signatures remain bound to the previous version.*/}
                                Customers will keep signing your current waiver until you publish this draft. 
                                Published changes apply to new signers only.
                            </p>
                        </>
                    )}

                    <div className="mt-6">

                        <div className="font-medium text-gray-900 mb-2">
                            Change Summary (for new versions only)
                        </div>

                        <ul className="list-disc ml-5 text-sm text-gray-700 space-y-1">

                            <li>
                                {data.eligibilityRulesModified} Eligible {data.eligibilityRulesModified === 1 ? "rule" : "rules"} modified
                            </li>

                            <li>
                                {data.sectionsEdited} {data.sectionsEdited === 1 ? "section" : "sections"} edited
                            </li>

                            {/* <li>
                                {data.clausesAdded} {data.clausesAdded === 1 ? "clause" : "clauses"} added
                            </li> */}

                            {data.stateClausesModified > 0 && (
                                <li>
                                    {data.stateClausesModified}{" "}
                                    {data.stateClausesModified === 1 ? "state clause" : "state clauses"} modified
                                </li>
                            )}

                            {data.minorsChanged && (
                                <li>
                                    Minor signer policy changed
                                </li>
                            )}

                            {data.returningSignerChanged && (
                                <li>
                                    Returning signer policy changed
                                </li>
                            )}

                        </ul>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default ChangeSummary;